export enum SessionType {
  UPCOMING = 'upcoming',
  PAST = 'past'
}
